// Slice 39 — the CGC inspector surfaces the source of the per-category
// user-facing response guidance the model actually emits at runtime
// (see `packages/shared/src/admin.ts:ClassifierCategoryInspectorEntry`).
//
// The inspector copy the CGC signs off on (`guardrailCopy`) is the
// same in dev/staging/prod, but the wording the model emits in
// response to a fired category is sourced from either the dev/staging
// stub module (`packages/shared/src/maeve-category-stubs.ts`) or a
// `system_prompts` row (the only source in production). The badge is
// the only place a reviewer can see at a glance whether the fragments
// they approve here govern the model's runtime output in the current
// environment.
//
// Single source of truth — the badge lives here, not inline in
// `AdminGovernance.tsx` + `CgcDashboard.tsx`. A rename of "Dev stub
// source" → "Non-prod stub source" must land in one file.

export type StubSource = 'stub' | 'system_prompts';

export function StubSourceBadge({ source }: { source: StubSource }) {
  if (source === 'stub') {
    return (
      <span
        className="rounded-full bg-muted px-2 py-0.5 text-[10px] font-medium tracking-normal text-muted-foreground uppercase"
        title="This worker's NODE_ENV is dev or staging — the per-category response fragment the model emits comes from packages/shared/src/maeve-category-stubs.ts, NOT a CGC-signed-off system_prompts row. Production will source its response guidance from system_prompts instead."
      >
        Dev stub source
      </span>
    );
  }
  return (
    <span
      className="rounded-full bg-traffic-green/10 px-2 py-0.5 text-[10px] font-medium tracking-normal text-traffic-green-text uppercase"
      title="This worker's NODE_ENV is production — the per-category response fragment the model emits comes from a CGC-signed-off system_prompts row (the stub module returns null in production)."
    >
      System_prompts source
    </span>
  );
}
